<template>
  <div class="tw-p-2 tw-border tw-border-primary tw-border-solid tw-rounded-xl">
    <ValidationProvider v-slot="{ errors }" :name="name" :rules="rules">
      <div class="input_wrapper">
        <label :for="name">{{ label }}</label>
        <v-file-input
          :disabled="btnLoading"
          :loading="btnLoading"
          @change="onFileSelect"
          :name="name"
          label=""
          v-model="file.mainMedia"
          :id="name"
          ref="uploadInput"
        ></v-file-input>
      </div>
      <span v-if="errors[0]" class="error--text d-inline-block">
        {{ errors[0] }}
      </span>
    </ValidationProvider>
    <div>
      <!-- <div size="120" class="user">
        <v-img :src="file.preview" class="profile-img"></v-img>
        <v-icon
          class="icon primary white--text"
          @click="$refs.FileInput.click()"
          >mdi-upload</v-icon
        >
        <input
          ref="FileInput"
          type="file"
          style="display: none;"
          @change="onFileSelect"
        />
      </div> -->
      <v-dialog v-model="dialog" width="500">
        <v-card class="!tw-bg-white tw-flex-col">
          <VueCropper
            v-show="selectedFile"
            ref="cropper"
            :src="selectedFile"
            alt="Source Image"
            :viewMode="2"
            :minContainerHeight="200"
            :minContainerWidth="200"
            :cropBoxResizable="true"
            :cropBoxWidth="22"
            :cropBoxHeight="22"
          ></VueCropper>
          <div>
            <v-btn class="primary" @click="uploadImage(), (dialog = false)"
              >Crop</v-btn
            >
            <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  components: { VueCropper },
  props: {
    name: {
      required: true,
    },
    label: {
      required: false,
    },
    rules: {
      required: true,
    },
    type: {
      required: false,
      default: "text",
    },
    value: {
      required: true,
    },
    placeholder: {
      required: false,
    },
    modalName: {
      required: false,
    },
  },
  data() {
    return {
      file: {
        mainMedia: null,
        preview: null,
        image: null,
        alt_ar: null,
        alt_en: null,
      },
      mime_type: "",
      cropedImage: "",
      btnLoading: false,
      autoCrop: false,
      selectedFile: "",
      image: "",
      dialog: false,
      files: "",
    };
  },

  methods: {
    uploadImage() {
      this.btnLoading = true;
      const data = new FormData();
      data.append("attachment_type", "image");
      data.append("model", this.modalName);
      this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        data.append("file", blob);
        this.axios({
          method: "POST",
          url: `${process.env.VUE_APP_BASE_URL_GENERAL}/api/general/attachments`,
          data: data,
        })
          .then((res) => {
            this.file.image = res.data.data;
            this.file.preview = URL.createObjectURL(blob);
            this.$emit("input", this.file);
            this.btnLoading = false;
          })
          .catch((err) => {
            this.file.mainMedia = null;

            this.$iziToast.error({
              title: this.$t("validation.error"),
              message: err.response.data.message,
            });

            this.btnLoading = false;
          });
      }, this.mime_type);
    },

    onFileSelect(e) {
      const file = e;

      // cropper.setData(data)

      this.mime_type = "image/png";
      if (typeof FileReader === "function") {
        this.dialog = true;
        const reader = new FileReader();
        reader.onload = (event) => {
          this.$refs.cropper.getCropBoxData({ width: 22, height: 22 });

          this.$refs.cropper.setCropBoxData({
            cropBoxData: { width: 22, height: 22 },
          });

          this.selectedFile = event.target.result;
          this.$refs.cropper.replace(this.selectedFile);
          // console.log(this.$refs.cropper);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    updateValue() {
      this.$emit("input", this.file);
    },
  },
};
</script>

<style></style>
